import { render } from "./ApartmentsList.vue?vue&type=template&id=1c29f461"
import script from "./ApartmentsList.vue?vue&type=script&lang=js"
export * from "./ApartmentsList.vue?vue&type=script&lang=js"
script.render = render

export default script